// Golf Elite subscription plans. Prices (display) + Stripe Price IDs come from
// env/config — never hardcoded amounts. Placeholders show "$—" until configured.
export const GOLF_ELITE_PLANS = {
  monthly: {
    id: 'monthly',
    label: 'Monthly',
    priceId: import.meta.env.VITE_GE_PRICE_MONTHLY || '',
    display: import.meta.env.VITE_GE_PRICE_MONTHLY_DISPLAY || '$—',
    per: '/mo',
    note: '',
  },
  annual: {
    id: 'annual',
    label: 'Annual',
    priceId: import.meta.env.VITE_GE_PRICE_ANNUAL || '',
    display: import.meta.env.VITE_GE_PRICE_ANNUAL_DISPLAY || '$—',
    per: '/yr',
    note: '',
  },
}

export const GOLF_ELITE_FEATURES = [
  'Unlimited tournaments & every format',
  'Live leaderboards and TV boards',
  'QR no-login mobile scoring',
  'Handicaps & flighting',
  'Online registration & entry fees',
  'AI tournament assistant',
]
